var _g, _path, _g2, _circle, _circle2, _g3, _circle3, _g4, _circle4, _path2, _path3, _path4, _path5, _g5, _path6, _g6, _path7, _path8, _path9, _g7, _circle5, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirerescue1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f14e3a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.9 23h-11c-1.1 0-2 .9-2 2s.9 2 2 2h11zm43 10-6-6h-26c-1.1 0-2 .9-2 2v22h34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.9 23h-8.2c-1.1 0-1.7.9-1.8 2l-2.9 11-1.6 1.1c-.9.6-1.9 1.8-2.1 2.9l-1.3 9c-.2 1.1.6 2 1.7 2h18.3v-26c-.1-1.1-1-2-2.1-2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.3 33 .7-5c.1-.5-.3-1-.9-1h-2l-2.1 9m12.9-4c0 .6-.4 1.3-.9 1.5l-4.3 1.5c-.5.2-.8-.2-.7-.7l.7-6.2c.1-.6.5-1 1-1h3.4c.5 0 .9.4.8 1z",
    fill: "#3e4347"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#e1e8ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.8 49c1.3.7 2.3 1.7 3.1 3h3.1v-3zm-15.8 2v4c0 1.1.9 2 2 2h2c0-.3-.1-.7-.1-1 0-3 1.6-5.6 4.1-7h-6c-1.1 0-2 .9-2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9 52c-1.5-3.5-5-6-9-6s-7.5 2.5-9 6z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9,
    cy: 56,
    fill: "#3e4347",
    r: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9,
    cy: 56,
    fill: "#b2c1c0",
    r: 5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e4347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.9 51.7c-.8 0-1.2.5-.9 1.2l.5 1.4c.2.6.6.6.9 0l.5-1.4c.2-.7-.2-1.2-1-1.2m-4 3c-.3.7.1 1.3.8 1.2l1.4-.1c.7 0 .8-.4.3-.8l-1.1-.9c-.6-.4-1.2-.1-1.4.6m1.5 4.8c.6.4 1.3.3 1.4-.4l.4-1.4c.2-.7-.1-.9-.7-.5l-1.1.8c-.6.3-.6 1 0 1.5m5.1 0c.6-.4.6-1.1.1-1.5l-1.2-.8c-.6-.4-.9-.2-.7.5l.4 1.4c.1.6.7.8 1.4.4m1.5-4.8c-.2-.7-.9-1-1.4-.5l-1.1.8c-.5.4-.4.8.3.8l1.4.1c.7.1 1-.5.8-1.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.9,
    cy: 56,
    r: 8
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9,
    cy: 56,
    fill: "#b2c1c0",
    r: 5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e4347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.9 51.7c-.8 0-1.2.5-.9 1.2l.5 1.4c.2.6.6.6.9 0l.5-1.4c.2-.7-.2-1.2-1-1.2m-4 3c-.2.7.1 1.3.8 1.2l1.4-.1c.7 0 .8-.4.3-.8l-1.1-.9c-.6-.4-1.2-.1-1.4.6m1.5 4.8c.6.4 1.3.3 1.4-.4l.4-1.4c.2-.7-.1-.9-.7-.5l-1.2.8c-.5.3-.5 1 .1 1.5m5.1 0c.6-.4.6-1.1.1-1.5l-1.2-.8c-.6-.4-.9-.2-.7.5l.4 1.4c.1.6.7.8 1.4.4m1.5-4.8c-.2-.7-.9-1-1.4-.5l-1.1.8c-.5.4-.4.8.3.8l1.4.1c.7.1 1-.5.8-1.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.9,
    cy: 56,
    r: 8
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.9,
    cy: 56,
    fill: "#b2c1c0",
    r: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m54.9 51.7c-.8 0-1.2.5-.9 1.2l.5 1.4c.2.6.6.6.9 0l.5-1.4c.2-.7-.2-1.2-1-1.2m-4 3c-.2.7.1 1.3.8 1.2l1.4-.1c.7 0 .8-.4.3-.8l-1.1-.9c-.6-.4-1.2-.1-1.4.6m1.5 4.8c.6.4 1.3.3 1.4-.4l.4-1.4c.2-.7-.1-.9-.7-.5l-1.2.8c-.5.3-.5 1 .1 1.5m5.1 0c.6-.4.6-1.1.1-1.5l-1.2-.8c-.6-.4-.9-.2-.7.5l.4 1.4c.1.6.7.8 1.4.4m1.5-4.8c-.2-.7-.9-1-1.4-.5l-1.1.8c-.5.4-.4.8.3.8l1.4.1c.7.1 1-.5.8-1.2",
    fill: "#3e4347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26.9 35h-4c-.5 0-1 .5-1 1v16h6v-16c0-.5-.4-1-1-1",
    fill: "#b3bdc4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m62 49c-1.8-1.8-4.3-3-7.1-3h-17c-2.7 0-5.2 1.2-7 3h-3v3h3.1c1.4-2.4 4-4 6.9-4 3 0 5.5 1.6 6.9 4h3.2c1.4-2.4 4-4 6.9-4 4.4 0 8 3.6 8 8v.8c.7-.3 1.1-1 1.1-1.8v-4c0-1.1-.9-2-2-2m-43.1-30h-2c0-.5-.4-1-1-1h-3c-2.2 0-4 1.8-4 4v1h11z",
    fill: "#e1e8ed"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m14.9 19h-2c-1.7 0-3 1.3-3 3v1h6v-3c0-.5-.4-1-1-1",
    fill: "#42ade2"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#b8331e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.9 43h-16c-1.7 0-3-1.3-3-3v-6c0-1.7 1.3-3 3-3h16c1.7 0 3 1.3 3 3v6c0 1.7-1.3 3-3 3m-16-10c-.6 0-1 .4-1 1v6c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.9 35h18v1h-18zm0 3h18v1h-18z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m54.2 21.3-2.9-11.1-2.2-.6 2.9 11.1z",
    fill: "#b2c1c0"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e4347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.2 3.8c-.1.5-.7.8-1.2.7s-.9-.7-.7-1.2l.5-1.9c.1-.5.7-.9 1.2-.7.5.1.9.7.7 1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.8 5.6-4.5-2.3.5-1.9 5.1.3z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m19.746 6.63 1.035-3.864 28.977 7.764-1.035 3.864z",
    fill: "#e1e8ed"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m53.1 9.4-24.5-6.6-2.2-.6-.8.8-4.1 4.1-1 3.9-7.6-2-.5 1.9 25.1 6.7 1.4 2.4 12.6 3.4.5-1.9 1.9.5 2-1.9v-5.8zm-30.4 2.1 1-3.9 2.7-2.6 2.1 8.2zm5.7-6.7 6.9 1.8-5.1 5.1zm2.6 9 6-6 2.2 8.2zm10.4 2.7-2.4-8.9 8.8 2.4z",
    fill: "#b3bdc4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m20.3.6-1.9-.6c-.5-.1-1.1.2-1.2.7l-2.3 8.7 3.9 1 2.2-8.6c.1-.6-.2-1.1-.7-1.2",
    fill: "#b2c1c0"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#3e4347"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.3,
    cy: 4.2,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.9 16-7 7h-3v4h17v-11z"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1,
    cy: 21,
    fill: "#e1e8ed",
    r: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m26.4 47c0-.5-.4-1-1-1h-1c-.5 0-1 .5-1 1v1c0 .5.5 1 1 1h1c.6 0 1-.5 1-1z",
    fill: "#f14e3a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirerescue1);
export default __webpack_public_path__ + "static/media/firerescue1.a9b807bbd047614f5044f27731ba9d1e.svg";
export { ForwardRef as ReactComponent };